import { StyleSheet } from 'react-native';

const DashboardButtonImage = ({ style }) => {
  const oneX = require('./dashboard-button.jpg');
  const twoX = require('./dashboard-button@2x.jpg');
  return (
    <img
      src={twoX}
      alt=""
      style={StyleSheet.flatten(style)}
      srcSet={`${oneX}, ${twoX} 2x`}
    />
  );
};

export { DashboardButtonImage };
